module.exports = __webpack_public_path__ + "media/images/arrows/twisted/orange-vertical-8091c9dbd4804550ab0289f8949eb500.svg";